import * as React from "react";
import { SingleNavMenuLinkCategoryEnd as ISingleNavMenuLinkCategoryEnd } from "../../../pages/identity/useNavMenu";

interface Props {
  link: ISingleNavMenuLinkCategoryEnd;
  index: number;
}
export const SingleNavMenuLinkCategoryEnd: React.FC<Props> = ({ link, index }) => {
  return (
    <div>
      <div className="mb-2" />
    </div>
  );
};
